import Analytics from '@web/services/Analytics/Analytics'

/**
 * Отправка поискового запроса. Шлётся на 100% сабмитов — основная цель фичи
 * (эпик SEARCH-HOME: сигнал спроса).
 * Отправляет: action, search_query, has_results, courses_count, event_date,
 * when_trigger, target
 */
export function analyticsSearchSubmit ({
  query,
  hasResults,
  coursesCount
}: {
  query: string;
  hasResults: boolean;
  coursesCount: number;
}): void {
  Analytics.send({
    action: 'search_submit',
    search_query: query,
    has_results: String(hasResults),
    courses_count: String(coursesCount),
    event_date: new Date().toISOString(),
    when_trigger: 'Пользователь отправил поисковый запрос',
    target: 'Поле поиска'
  })
}

/**
 * Ошибка поискового запроса. Отдельное событие, чтобы технические ошибки
 * не засчитывались как «ничего не найдено» и не искажали no-result rate
 * (эпик SEARCH-HOME, открытый вопрос F).
 * Отправляет: action, search_query, event_date, when_trigger, target
 */
export function analyticsSearchError ({ query }: { query: string }): void {
  Analytics.send({
    action: 'search_error',
    search_query: query,
    event_date: new Date().toISOString(),
    when_trigger: 'Запрос поиска завершился ошибкой',
    target: 'Страница результатов поиска'
  })
}

/**
 * Клик по карточке в результатах поиска — что пользователь открыл после поиска.
 * Отправляет: action, search_query, item_type, item_id, event_date,
 * when_trigger, target
 */
export function analyticsSearchResultClick ({
  query,
  itemType,
  itemId
}: {
  query: string;
  itemType: 'course' | 'club_material';
  itemId: number;
}): void {
  Analytics.send({
    action: 'search_result_click',
    search_query: query,
    item_type: itemType,
    item_id: String(itemId),
    event_date: new Date().toISOString(),
    when_trigger: 'Пользователь открыл карточку из результатов поиска',
    target: 'Карточка в результатах поиска'
  })
}
